import Alpine from 'alpinejs';
import { t } from '../helpers';

Alpine.data('minicartItem', (key) => ({
  working: false,
  key: key,

  get cart() {
    return Alpine.store('cart');
  },

  get item() {
    return this.cart.items.find((item) => item.key === this.key);
  },

  remove() {
    this.working = true;

    let title = this.item.title;

    Shopify.cart.remove(this.key)
      .then((cart) => {
        this.$dispatch('toast:show', {
          type: 'success',
          message: t('removed-item-from-cart', { title }),
        }, true);
      })
      .catch((error) => {
        this.$dispatch('toast:show', {
          type: 'error',
          message: t('error-removing-item-from-cart', { title }),
        }, true);
      }).finally(() => {
        this.working = false;
      });
  },

  update(quantity) {
    this.working = true;

    let title = this.item.title;

    Shopify.cart.change(this.key, quantity)
      .catch((error) => {
        this.$dispatch('toast:show', {
          type: 'error',
          message: t('error-updating-item-in-cart', { title }),
        }, true);
      }).finally(() => {
        this.working = false;
      });
  }
}));